import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProgressBarDetails } from '../api/models/ProgressBarDetails';
@Injectable()
export class ProgressBarService {
    pb: ProgressBarDetails;

    constructor(@Inject(HttpClient) private httpclient: HttpClient) {

    }    
}